import styles from '../styles/scrollable.scss';

export default function scrollParent() {
  return typeof window !== 'undefined'
    ? document.getElementsByClassName(styles.scrollable)[0] || document.body
    : null;
}
